import { formatMoney, getSizedImageUrl } from '//zigarrendepotdepot.com/cdn/shop/t/94/assets/theme.js?v=34606369793379638831792174063';

function debouncePromise(fn, time) {
  let timer;
  return function debounced(...args) {
    if (timer) clearTimeout(timer);
    return new Promise((resolve) => {
      timer = setTimeout(() => resolve(fn(...args)), time);
    });
  };
}

const DEBOUNCE_MS = 400;
const debouncedSources = debouncePromise((items) => Promise.resolve(items), DEBOUNCE_MS);

function saveRecentSearch(query) {
  const RECENT_KEY = 'recentSearches';
  let recent = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');

  recent = recent.filter(q => q !== query);
  recent.unshift(query);

  localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, 10)));
}

function removeRecentSearch(queryToRemove, autocompleteInstance) {
  const RECENT_KEY = 'recentSearches';
  const stored = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
  const updated = stored.filter((q) => q !== queryToRemove);
  localStorage.setItem(RECENT_KEY, JSON.stringify(updated));

  const el = document.querySelector(`.aa-recentSearch-item[data-query="${CSS.escape(queryToRemove)}"]`);
  if (el) el.remove();

  if (autocompleteInstance) {
    autocompleteInstance.refresh();
  }
}

const getLanguageByDomain = () => {
  const url = new URL(window.location.href);
  const hostname = url.hostname;

  if (hostname.endsWith(".de")) {
    return "de";
  } else if (hostname.endsWith(".com")) {
    return "en";
  } else {
    return "de";
  }
}

function setAlgoliaSearchTranslations() {
  const interval = setInterval(() => {
    if (
      window.algoliaShopify &&
      algoliaShopify.translations &&
      typeof algoliaShopify.translations.products !== 'undefined'
    ) {
      clearInterval(interval);

    if(getLanguageByDomain() == "de") {
      algoliaShopify.translations.collections = "Kategorien";
      algoliaShopify.translations.clearAll = "Alle zurücksetzen";
      algoliaShopify.translations.noResultFor = "Keine Ergebnisse für";
      algoliaShopify.translations.outOf = "von";
      algoliaShopify.translations.pages = "Seiten";
      algoliaShopify.translations.suggestions = "Suchvorschläge";
      algoliaShopify.translations.searchForProduct = "Suche";
      algoliaShopify.translations.selectedFilter = "Ausgewählte Filter";
      algoliaShopify.translations.products = "Produkte";
      algoliaShopify.translations.showMore = "Mehr anzeigen";
      algoliaShopify.translations.showLess = "Weniger anzeigen";
      algoliaShopify.translations.search = "Suche";
      algoliaShopify.translations.searchTitle = "Suchergebnisse";
      algoliaShopify.translations.resultsFound = "Ergebnisse gefunden";
      algoliaShopify.translations.articles = "Artikel";
      algoliaShopify.translations.allProducts = "Alle Produkte ";
      algoliaShopify.translations.sortBy = "Sortieren nach";
      algoliaShopify.translations.noResultFound = "Keine Ergebnisse gefunden";
      algoliaShopify.translations.oneResultFound = "1 Ergebnis gefunden";
      algoliaShopify.translations.relevance = "Unsere Empfehlung";
      algoliaShopify.translations.articles = "Artikel";
      algoliaShopify.translations.cancel = "X";


      if(typeof algoliaShopify.translations.facets !== "undefined" && Array.isArray(algoliaShopify.translations.facets)) {
        for (let i = 0; i < algoliaShopify.translations.facets.length; i++) {
          algoliaShopify.translations.facets[i].title = algoliaShopify.translations.facets[i].title.replace("Price range", "Preisspanne").replace("Price", "Preis").replace("Vendor", "Marken").replace("Type", "Kategorien").replace("Selected filters", "Filter");
        }
      }
    }
    }
  }, 50);
}

const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js'];
const { createRedirectUrlPlugin } = window['@algolia/autocomplete-plugin-redirect-url'];

const searchClient = algoliasearch(
  'DOWRDBU35W',
  'da1ad753b1212cc9a7439c63c819ddc6'
);

const redirectUrlPlugin = createRedirectUrlPlugin({
  searchClient,
  indexName: 'shopify_live_store_de_products',
});

let aaInstance = null;
let currentIsMobile = window.matchMedia('(max-width: 1149px)').matches;
function initAutocomplete() {
  const isMobile = window.matchMedia('(max-width: 1149px)').matches;

  if (aaInstance && typeof aaInstance.destroy === 'function') {
    aaInstance.destroy();
  }

  const commonOptions = {
    placeholder: 'Liquid-Life durchsuchen',
    openOnFocus: true,
    plugins: [redirectUrlPlugin],
    detachedMediaQuery: 'none',
    translations: {
      detachedCancelButtonText: 'Schließen',
    },
    stallThreshold: 500,
    onSubmit({ state }) {
      const query = state.query.trim();
      if (query.length > 0) {
        window.location.href = `/search?q=${encodeURIComponent(query)}`; // Fallback
      }
    },

    getSources({ query, state }) {
      const sources = [];

      // Recent Searches
      if (!query) {
        sources.push({
          sourceId: 'recentSearches',
          getItemInputValue: ({ item }) => item.query,
          getItems() {
            const RECENT_KEY = 'recentSearches';
            const stored = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
            return stored.slice(0, 4).map((query) => ({ query }));
          },
          templates: {
            item({ item, html }) {
              const q = item.query;

              return html`
                <div class="aa-ItemWrapper aa-recentSearch-item" data-query="${q}">
                  <a class="aa-ItemLink" href="/search?q=${encodeURIComponent(q)}" style="flex-grow: 1;">
                    <div class="aa-ItemContent">
                      <div class="aa-ItemIcon aa-ItemIcon--noBorder aa-recentSearch--color">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M12 7V12L14.5 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="aa-ItemContentBody">
                        <div class="aa-ItemContentTitle aa-recentSearch--color">${q}</div>
                      </div>
                    </div>
                  </a>
                  <div class="aa-ItemActions">
                  <button
                    type="button"
                    class="aa-recentSearch-remove"
                    title="Entfernen"
                    style="background: none; border: none; cursor: pointer; padding: 0 0.5rem;"
                    data-query="${q}"
                  >
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                  </div>
                </div>
              `;
            }
          }
        });
      }

      // Query Suggestions
      sources.push({
        sourceId: 'querySuggestions',
        getItemInputValue: ({ item }) => item.query,
        getItems() {
          return getAlgoliaResults({
            searchClient,
            queries: [
              {
                indexName: 'shopify_live_store_de_products_top3',
                params: {
                  query,
                  hitsPerPage: 3,
                },
              },
            ],
          });
        },
        templates: {
          header({ html }) {
            if (state.query) return null;
            return html`
              <div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle">TREND - TOP 3</span>
                <div class="aa-SourceHeaderLine" />
              </div>
            `;
          },
          item({ item, html, state }) {
            const iconSvg = state.query
              ? html`
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"></path>
                </svg>`
              : html`
                <svg width="800px" height="800px" viewBox="0 0 24 24" fill="currentColor" >
                  <path d="M1.41421 16.4322L0 15.018L7.07107 7.94693L13.435 14.3109L17.6777 10.0682L15.9353 8.32587L22.6274 6.53271L20.8343 13.2248L19.0919 11.4825L13.435 17.1393L7.07107 10.7754L1.41421 16.4322Z"/>
                </svg>`;

            return html`
              <a class="aa-ItemLink aa-ItemWrapper" href="/search?q=${encodeURIComponent(item.query)}">
                <div class="aa-ItemContent">
                  <div class="aa-ItemIcon aa-ItemIcon--noBorder">${iconSvg}</div>
                  <div class="aa-ItemContentBody">
                    <div class="aa-ItemContentTitle">
                      ${state.query
                        ? html`<mark>${state.query}</mark>${item.query.slice(state.query.length)}`
                        : item.query}
                    </div>
                  </div>
                </div>
              </a>
            `;
          },
        },
      });

      // Collections (nur bei Query)
      if (query) {
        sources.push({
          sourceId: 'collectionItems',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: 'shopify_live_store_de_collections',
                  query,
                  params: {
                    hitsPerPage: 3,
                    attributesToSnippet: ['title:20'],
                    snippetEllipsisText: '…',
                  },
                },
              ],
            });
          },
          templates: {
            header({ html }) {
              return html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle">${window.algoliaShopify.translations.collections}</span>
                  <div class="aa-SourceHeaderLine" />
                </div>
              `;
            },
            item({ item, html, components }) {
              return html`
                <a class="aa-ItemLink" href="/collections/${item.handle}">
                  <div class="aa-ItemWrapper">
                    <div class="aa-ItemContent">
                      <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M17 10H19C21 10 22 9 22 7V5C22 3 21 2 19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17V19C2 21 3 22 5 22Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="aa-ItemContentBody">
                        <div class="aa-ItemContentTitle">
                          ${components.Snippet({ hit: item, attribute: 'title' })}
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              `;
            },
          },
        });
      }
      
      // Pages (nur bei Query)
      if (query) {
        sources.push({
          sourceId: 'pageItems',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: 'shopify_live_store_de_pages',
                  query,
                  params: {
                    hitsPerPage: 2,
                    attributesToSnippet: ['title:20'],
                    snippetEllipsisText: '…',
                  },
                },
              ],
            });
          },
          templates: {
            header({ html }) {
              return html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle">${window.algoliaShopify.translations.pages}</span>
                  <div class="aa-SourceHeaderLine" />
                </div>
              `;
            },
            item({ item, html, components }) {
              return html`
                <a class="aa-ItemLink" href="/pages/${item.handle}">
                  <div class="aa-ItemWrapper">
                    <div class="aa-ItemContent">
                      <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M3 15H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="aa-ItemContentBody">
                        <div class="aa-ItemContentTitle">
                          ${components.Snippet({ hit: item, attribute: 'title' })}
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              `;
            },
          },
        });
      }
      
      // Products (nur bei Query)
      if (query) {
        sources.push({
          sourceId: 'productItems',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: 'shopify_live_store_de_products',
                  query,
                  params: {
                    hitsPerPage: 6,
                    attributesToSnippet: ['title:10'],
                    snippetEllipsisText: '…',
                    distinct: true,
                  },
                },
              ],
            });
          },
          templates: {
            header({ html }) {
              return html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle">${window.algoliaShopify.translations.products}</span>
                  <div class="aa-SourceHeaderLine" />
                </div>
              `;
            },
            item({ item, html, components }) {
              const isOnSale = item.compare_at_price > item.price;
              const price = (item.price).toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR',
              });
              const compareAtPrice = (item.compare_at_price).toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR',
              });

              return html`
                <a class="aa-ItemLink" href="/products/${item.handle}?variant=${item.objectID}">
                  <div class="aa-ItemContent">
                    <div class="aa-ItemIcon aa-ItemIcon--picture aa-ItemIcon--alignTop">
                      <img src="${item.image || item.images?.[0]}" alt="${item.title}" width="40" height="40" />
                    </div>
                    <div class="aa-ItemContentBody">
                      <div class="aa-ItemContentTitle">
                        ${components.Snippet({ hit: item, attribute: 'title' })} 
                        ${
                          (item._highlightResult?.sku?.matchedWords?.length > 0 ||
                          item._highlightResult?.variants?.some(v => v.sku?.matchedWords?.length > 0))
                            ? (item.variant_title ? ` (${item.variant_title})` : '')
                            : ''
                        }
                      </div>
                      <div class="aa-ItemContentDescription" style="color: #000;">
                        ${isOnSale ? html`
                          <strong style="color: rgb(236,70,61);">${price}</strong>
                          <span style="text-decoration: line-through; margin-left: 0.5rem;">${compareAtPrice}</span>
                        ` : html`
                          <strong>${price}</strong>
                        `}
                      </div>
                    </div>
                  </div>
                </a>
              `;
            },
          },
        });
      }

      return query ? debouncedSources(sources) : sources;
    }
  };

  aaInstance = autocomplete({
    container: isMobile ? '#autocomplete-mobile' : '#autocomplete-desktop',
    panelContainer: isMobile ? '#autocompleteresult-mobile' : '#autocompleteresult-desktop',
    onStateChange({ state }) {
      const overlay = document.querySelector(
        isMobile ? '#search-page-overlay--mobile' : '#search-page-overlay--desktop'
      );
      const form = document.querySelector(
        isMobile ? '#autocomplete-mobile .aa-Form' : '#autocomplete-desktop .aa-Form'
      );

      if (state.isOpen) {
        overlay?.classList.add('active');
        form?.style.setProperty('border-bottom-left-radius', '0px', 'important');
        form?.style.setProperty('border-bottom-right-radius', '0px', 'important');
      } else {
        overlay?.classList.remove('active');
        form?.style.setProperty('border-bottom-left-radius', '22px', 'important');
        form?.style.setProperty('border-bottom-right-radius', '22px', 'important');
      }
      form?.style.setProperty('border-top-left-radius', '22px', 'important');
      form?.style.setProperty('border-top-right-radius', '22px', 'important');

      requestAnimationFrame(() => {
        document.querySelectorAll('.aa-recentSearch-remove').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const query = btn.getAttribute('data-query');
            removeRecentSearch(query, aaInstance); 
          });
        });
      });
    },
    ...commonOptions
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setAlgoliaSearchTranslations();

  initAutocomplete();
    
  setTimeout(() => {
    const overlay = document.querySelector('#search-page-overlay');

    const configs = [
      {
        input: document.querySelector('#autocomplete-desktop .aa-Input'),
        form: document.querySelector('#autocomplete-desktop .aa-Form'),
      },
      {
        input: document.querySelector('#autocomplete-mobile .aa-Input'),
        form: document.querySelector('#autocomplete-mobile .aa-Form'),
      }
    ];

    configs.forEach(({ input, form }) => {
      if (!input || !form) return;

      form.addEventListener('submit', (event) => {
        const query = input.value.trim();
        if (query.length > 0) {
          saveRecentSearch(query);
        }
      });
    });

    overlay?.addEventListener('click', () => {
      configs.forEach(({ input }) => input?.blur());
    });
  }, 0);

  window.addEventListener('resize', () => {
    const isNowMobile = window.matchMedia('(max-width: 1149px)').matches;

    if (isNowMobile !== currentIsMobile) {
      currentIsMobile = isNowMobile;
      initAutocomplete();
    }
  });

});

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {
    if(getLanguageByDomain() == "de") {
      options.numberLocale = 'de';
    }

    setAlgoliaSearchTranslations();

    return options;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('q');

    return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle} "${query}"</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          <div class="text-with-icon justify-center"><svg role="presentation" fill="none" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-filter" viewBox="0 0 20 14">
            <path d="M1 2C0.447715 2 0 2.44772 0 3C0 3.55228 0.447715 4 1 4V2ZM1 4H5V2H1V4Z" fill="currentColor"></path>
            <path d="M1 10C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12V10ZM1 12H11V10H1V12Z" fill="currentColor"></path>
            <path d="M10 2H9V4H10V2ZM19 4C19.5523 4 20 3.55228 20 3C20 2.44772 19.5523 2 19 2V4ZM10 4H19V2H10V4Z" fill="currentColor"></path>
            <path d="M16 10H15V12H16V10ZM19 12C19.5523 12 20 11.5523 20 11C20 10.4477 19.5523 10 19 10V12ZM16 12H19V10H16V12Z" fill="currentColor"></path>
            <circle cx="7" cy="3" r="2" stroke="currentColor"></circle>
            <circle cx="13" cy="11" r="2" stroke="currentColor"></circle>
            </svg><span style="font-weight: bold;">Filtern und sortieren</span>
          </div>
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}" >    
                  <label class="facet-label" data-facet-name="${facet.escapedName}">
                    <div class="accordion__toggle">                   
                      <span class="ais-range-slider--header ais-facet--header ais-header">${facet.title}</span>
                      <span class="default-chevron">
                        <svg role="presentation" focusable="false" width="10" height="7" class="icon icon-chevron-bottom" viewBox="0 0 10 7">
                          <path d="m1 1 4 4 4-4" fill="none" stroke="currentColor" stroke-width="2"></path>
                        </svg>
                      </span>                   
                    </div>
                  </label>
                  <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown"/>                  
                  <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container" data-facet-name="${facet.escapedName}" hidden></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html) {
    const handle = hit.handle;
    const variantID = hit.objectID;
    const placeholderId = `product-card-${handle}`;

    setTimeout(() => {
      fetch(`/products/${handle}?variant=${variantID}&section_id=algolia-product-card`)
        .then(res => res.text())
        .then(htmlString => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          const card = doc.querySelector('product-card') || doc.querySelector('.product-card') || doc.body.firstElementChild;

          const target = document.getElementById(placeholderId);
          if (target && card) {
            target.replaceWith(card);
          }
        })
        .catch(error => {
          console.error(`Fehler beim Laden der Produktkarte für ${handle}:`, error);
        });
    }, 0); 

    return html`
      <div id="${placeholderId}" class="algolia-product-card-placeholder">
        <div class="loading"></div>
      </div>
    `;
  });
});

function algoliaFacetListeners() {
    const labels = document.querySelectorAll('label.facet-label');
    labels.forEach(function(label) {
        if (!label.dataset.listenerAdded) {
            label.addEventListener('mouseup', function(event) {
                var chevron = this.querySelector('.icon-chevron-bottom');
                if (chevron) {
                    chevron.classList.toggle('rotate');
                }
                var facetName = this.dataset.facetName;
                var dropdownContainers = document.querySelectorAll('.ais-facet-dropdown-container');
                
                dropdownContainers.forEach(function(container) {
                    if (container.dataset.facetName === facetName) {
                        container.toggleAttribute('hidden');
                    }
                });
            });
            label.dataset.listenerAdded = 'true';
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    algoliaFacetListeners();
    const facetObserver = new MutationObserver(algoliaFacetListeners);
    facetObserver.observe(document.body, { childList: true, subtree: true });
});

// window.sendAlgoliaEvent = function(action, objectIDs) {
//   aa("init", {
//     appId: "DOWRDBU35W",
//     apiKey: "da1ad753b1212cc9a7439c63c819ddc6",
//   });

//   switch (action) {
//     case "product_viewed":
//       window.aa("viewedObjectIDs", {
//         index: "shopify_live_store_de_products",
//         eventName: "productViewed",
//         objectIDs: objectIDs
//       });
//       break;

//     case "product_clicked":
//       window.aa("clickedObjectIDs", {
//         index: "shopify_live_store_de_products",
//         eventName: "productClicked",
//         objectIDs: objectIDs
//       });
//       break;
      
//     case "collection_viewed":
//       window.aa("viewedObjectIDs", {
//         index: "shopify_live_store_de_collections",
//         eventName: "collectionViewed",
//         objectIDs: objectIDs
//       });
//       break;

//     case "collection_clicked":
//       window.aa("clickedObjectIDs", {
//         index: "shopify_live_store_de_collections",
//         eventName: "collectionClicked",
//         objectIDs: objectIDs
//       });
//       break;
//     default:
//       console.error("Unbekannte Aktion:", action);
//   }
// };